<template>
  <div
    class="flex-center position-ref full-height"
    :style="!isFullWidth ? `height:100%` : ``"
  >
    <div class="content-splash">
      <div class="title">
        <b-img src="~@/assets/img/vello-say-it-to-my-face.png" alt="logo" />
      </div>

      <div class="links">
        <a :href="links.appStore">
          <b-img src="~@/assets/img/appstore.png" alt="appstore" />
        </a>
        <a :href="links.playStore">
          <b-img src="~@/assets/img/playstore.png" alt="playstore" />
        </a>
      </div>

      <b-container fluid class="ready-go" v-if="isFullWidth">
        <b-row>
          <b-col cols="8">
            <h2 class="font-weight-bold text-left">
              Premium? <br />
              Let's Go
            </h2>
          </b-col>
          <b-col cols="4">
            <b-link to="/login" class="float-right">
              <b-img
                class="next-arrow"
                src="~@/assets/img/next.png"
                alt="next"
              />
            </b-link>
          </b-col>
        </b-row>
      </b-container>

      <b-container fluid class="mt-5" v-if="half">
        <b-row>
          <b-col class="text-right">
            <a
              href="https://vello.vip/privacy-policy/"
              class="grey-light"
              target="_blank"
            >
              <small>Privacy Policy</small>
            </a>
          </b-col>
          <b-col class="text-left">
            <a
              href="https://vello.vip/user-terms"
              class="grey-light"
              target="_blank"
            >
              <small>Terms of Use</small>
            </a>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'LandingPage',
  props: ['half'],
  computed: {
    ...mapState({
      links: (state) => state.auth.links,
    }),

    isFullWidth: function () {
      return !this.half
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/layouts/splash';
</style>
